import { ReactComponent as HubIcon } from '../assets/images/LearnersHub.svg';
import { ReactComponent as SchoolIcon } from '../assets/images/hat.svg';
import { ReactComponent as ProfileIcon } from '../assets/images/profile.svg';
import { ReactComponent as TeamIcon } from '../assets/images/team.svg';
export const CONSTANTS = {
  NAVIGATE: {
    HOME: {
      name: 'Hub',
      icon: HubIcon,
      path: '/dashboard'
    },
    COURSES: {
      name: 'Learning',
      icon: SchoolIcon,
      path: '/courses'
    },
    PROFILE: {
      name: 'Profile',
      icon: ProfileIcon,
      path: '/profile'
    },
    TEAM: {
      name: 'Team',
      icon: TeamIcon,
      path: '/team'
    }
  }
};

export const LOGIN_MESSAGES = {
  EMAIL_INCORRECT: 'Inputted Incorrect Email Address',
  EMAIL_DISABLED: 'Your Account is disabled by your admin, contact for them for more Information',
  EMAIL_NOT_REGISTERED:
    'Email Address is not registered in the system, contact your admin for more Information',
  EMAIL_LOCKED: (time: any) =>
    `Your account has been temporarily locked due to too many failed login attempts. Please wait ${time} and try again.`,
  PASSWORD_WARNING:
    'You have failed to log in 3 times. If you fail to log in 5 times, your account will be locked.',
  PASSWORD_INCORRECT: 'Verification Code is incorrect',
  // EMAIL_EXPIRED: 'Your Company’s account with Phriendly Phishing has expired, contact your admin for support.',
  EMAIL_EXPIRED: (CompanyName: string) =>
    `${CompanyName} license with Phriendly Phishing has expired. Please contact your company administrator.`,
  EMAIL_NOT_ENABLE_MODULE:
    'Your account with Phriendly Phishing does not have Learner Hub Enabled. Please reach out to your internal IT team for more information',
  NOT_EXISTS_COGNITO: 'Account does not exist in Cognito',
  NOT_EXIST_IN_PH2:
    'Email address is not registered in the system, contact your admin for more Information',
  EMAIL_NOT_INPUT: 'Please enter a valid email address',
  OTP_HAS_EXPIRED: 'Verification Code has expired.'
};
export const KEY_PRESS = {
  NEXT: 'next',
  VERIFY: 'verify'
};

export const DASHBOARD_INTRO = {
  WELCOME: {
    title: 'Phriendly Phishing | welcome',
    author: 'Phriendly Phishing',
    date: '23/03/22',
    content:
      '<div className={"post-content"}>We welcome you to Phriendly Phishing’s Learners hub, this platform is designed to help you with your cyber security education to ensure<br/> you complete your training and are prepared for dealing with Phishing emails that you will encounter on a daily basis.<br/><br/>In the current climate we understand it may be difficult to see what is fake and real; however with Phriendly Phishing’s library of<br/> educational content we can help reduce your chances of falling prey to scammers/criminals by completing training courses set by your<br/> company leaders.',
    isShowAcceptBtn: false
  },
  PRIVACY: {
    title: 'Phriendly Phishing | Training Disclosure Notification',
    author: 'Company Admin',
    date: '23/03/22',
    userName: 'Your business name',
    content:
      '<div class="policy-wrap-content">' +
      '<div class="policy-content">' +
      '<p>Your participation, progress and results obtained during the courses provided by Phriendly Phishing, will be shared and made available to your employer.<br></p>' +
      '<p>Any results or Phriendly Phishing certifications, will also be available for you to access via a Phriendly Phishing Transcript, which can also be accessed upon request to Phriendly Phishing.<br></p>' +
      '<p>If you have left your employment, some results may no longer be available to you, if they are received as a result of sitting customised courses specific to your employer.<br></p>' +
      '<p>All other information that is collected, will be done pursuant and in compliance with the Phriendly Phishing Privacy Policy available <a href="https://www.phriendlyphishing.com/privacy-policy" style="color: #172B52" target="_blank" ><strong>here</strong></a>.<br></p>' +
      '</div>' +
      '</div>',
    isShowAcceptBtn: true
  }
};

export const FORMAT_DATE = {
  DATE: 'dd/MM/yyyy',
  DATE_TIME: 'dd/MM/yyyy HH:mm:ss',
  MONTH_YEAR: 'MMM yyyy',
  DATE_TIME_DASH: 'yyyy-MM-DD HH:mm:ss',
  DATE_TIME_ROUND_TRIP: 'Do MMMM',
  DATE_DAY_MONTH_YEAR: 'DD MMM yyyy',
  DATE_D_MMM_YYYY: 'D MMM yyyy'
};

export const FORMAT_MOMENT = {
  DATE: 'DD/MM/yyyy',
  DATE_TIME: 'DD/MM/yyyy HH:mm:ss',
  MONTH_YEAR: 'MMM YYYY',
  EEE: 'EEE',
  DAY: 'd',
  DATE_NAME: 'ccc dd MMM yy',
  DATE_TIME_DASH: 'YYYY-MM-DD HH:mm:ss',
  TIME: 'HH:mm:ss'
};
export const HAS_APPROVED = {
  FIRST_TIMES: '0',
  SECOND_TIMES: '1'
};

export const TRAINING_STATUS = {
  TN_FAILED: 1,
  TN_INCOMPLETE: 2,
  TN_NOT_START: 3,
  TN_PASSED: 4
};

export const STATUS = {
  TR_COMPLETED: 1,
  TR_EXPIRED: 2,
  TR_PAUSED: 3,
  TR_PENDING: 4,
  TR_REMOVED: 5,
  TR_RUNNING: 6,
  TR_STOPPED: 8
};
export const STATUS_COURSE = {
  OVERDUE: 'Outstanding',
  ASSIGNED: 'Assigned',
  PASS: 'Passed',
  PENDING: 'Pending',
  QUESTIONNAIRE: 'Completed'
};

export const TYPE_LETF_CARD_DETAIL = {
  GRADES: 'GradesOverview',
  ASSIGNED_LEARNING: 'AssignedLearning'
};
export const TAB_HEADER_TITLE = {
  POLICY_ACCEPTANCE: 'Training Disclosure',
  COURSE_RESULTES: 'Course Results'
};

export const TOOLTIP_MESSAGES = {
  PRIVACY_POLICY_ACCEPTED:
    'You have accepted the privacy policy, you now have access to the platform.',
  ACCEPT_POLICY_REQUIREMENT:
    'You are required by your organisation to read and accept the policy attached to this course',
  PROFILE_BADGE:
    'Recognition for milestones you’ve hit across your training and phishing activity.',
  PROFILE_EMAIL_CONTENT_TYPE:
    'Biases that influence how you respond to phishing emails (favourably or unfavourably).',
  PROFILE_ACTIVITY_TIMELINE:
    'Here is a timeline of the courses you have passed and phishing emails you have reported',
  PROFILE_CONTENT_HISTORY:
    'Here is a history of the courses you have passed and phishing emails you have reported',
  PROFILE_MY_PROFILE: ''
};

export const COURSE_POLICY_MESSAGE = {
  MANDATORY_POLICY_REQUIREMENT:
    'You are required by your organisation to read and accept the policy attached to the courses you have passed.',
  PROFILE_BADGE:
    'Achievements tied to actions you have completed in relation to your phishing training and behaviour',
  PROFILE_EMAIL_CONTENT_TYPE:
    'Here are contents within an email that you either respond ‘favorably’ or ‘unfavorably’',
  PROFILE_ACTIVITY_TIMELINE:
    'Here is a timeline of the courses you have passed and phishing emails you have reported',
  PROFILE_CONTENT_HISTORY:
    'Here is a history of the courses you have passed and phishing emails you have reported',
  PROFILE_MY_PROFILE: ''
};

export const BADGE_ACTION_TYPE = {
  COMPLETE: 'COMPLETE_LEARNING_COURSE',
  REPORT: 'REPORT_EMAIL'
};

export const HAS_VALUES = {
  TRUE: 1,
  FALSE: 0
};
export const COURSE_POLICY_STATUS = {
  NA: 0,
  MANDATORY: 1,
  ACCEPTED: 2
};

export const COURSE_GRADE = {
  NOT_AVAILABLE: 'N/A',
  NOT_REQUIRED: 'Not Required'
};
export const COURSE_POLICY_ACCEPTANCE = {
  ACCEPTED: 'Accepted',
  NOT_ACCEPTED: 'Not Accepted',
  NOT_AVAILABLE: 'N/A'
};

export const PARAMS_COURSE_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed'
};

export const COURSE_TAB = {
  PENDING: 'Pending',
  COMPLETED: 'Completed'
};

export const CATEGORY_TYPE = {
  TRAINING: 'Training',
  QUESTIONNAIRE: 'Questionnaire'
};
export const BADGES_LEVEL_ORDER = ['Opal', 'Diamond', 'Emerald', 'Gold', 'Silver', 'Bronze'];

// Badge filtering configurations for training and phishing badges
export const BADGE_FILTER_CONFIGS = {
  TRAINING_CATEGORIES: ['training_completion'],
  TRAINING_STREAK_BADGES: ['SURVEY_SPECIALIST', 'QUIZ_WHIZ', 'EARLY_BIRD', 'CONSISTENCY_CAPTAIN', 'PERFECT_STREAK'],
  PHISHING_CATEGORIES: ['attack_vector', 'cognitive_bias', 'reported_emails'],
  PHISHING_STREAK_BADGES: ['INBOX_VIGILANTE', 'SUSPICION_SPECIALIST', 'CYBER_SLEUTH', 'TURBO_TRAWLER']
};

export const LEADERBOARD_TABS = {
  EMAIL_REPORTING: 'Email Reporting',
  COURSE_COMPLETION: 'Course Completion',
  ACHIEVEMENT_COMPLETION: 'Achievement Completion'
}